import React from 'react'

import './Footer.scss'

// Footer is a simple component used for the site's footer
const Footer = () => {
  return (
    <footer className="footer">
      <p>By Shawn</p>
      <p>&copy;2019</p>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/footer/Footer.js